import React from 'react';

export default function Memberkit() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='white'
      />
      <path
        d='M6.00406 23H23.2959L14.253 9.6971C14.253 9.6971 13.9626 9 12.5296 9C11.2904 9 10.9225 9.6971 10.9225 9.6971L4.47432 19.2241C4.47432 19.2241 3.60295 20.2503 4.22259 21.5671C4.84064 22.8804 6.00406 23 6.00406 23Z'
        fill='#2726B0'
      />
      <path
        d='M26.7909 23H9.49902L18.5419 9.6971C18.5419 9.6971 18.8324 9 20.2653 9C21.5046 9 21.8725 9.6971 21.8725 9.6971L28.3206 19.2241C28.3206 19.2241 29.192 20.2503 28.5723 21.5671C27.9543 22.8804 26.7909 23 26.7909 23Z'
        fill='url(#paint0_linear_5187_42869)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5187_42869'
          x1='10.5059'
          y1='16.242'
          x2='28.7853'
          y2='16.242'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#1BEEEA' />
          <stop offset='0.5' stop-color='#699DF1' />
          <stop offset='1' stop-color='#D4A1F2' />
        </linearGradient>
      </defs>
    </svg>
  );
}
